<script lang="ts" setup>
import { computed, inject } from 'vue'
import {useSettingsStore } from '@/store/settings'
import FeaturedLink from '@/components/FeaturedLink.vue';
import { storeToRefs } from "pinia";
import { type Cta, getCtaLink } from "@interfaces/Cta.ts";
// import { route } from "ziggy-js";
let route = inject('route')
const settings = useSettingsStore()
let { user } = storeToRefs(settings)
let props = defineProps({
    links: {
        type: Array as PropType<Cta[]>,
        required: true,
        default: []
    }
})
let featuredLinks = computed(()=> {
    if(props.links.length > 0) {
        return props.links.filter(link =>{
            switch(link.for_customer_type){
                case 'consumer':
                    return !user.value.is_dealer
                case 'dealer':
                    return user.value.is_dealer
                default:
                    return true
            }
        }).map((link)=>{
            return {
                title: link.label,
                url: getCtaLink(link).href,
                caption: link.caption,
                aria_label: link.aria_label,
            }
        })
    }

    return [
        // links include {{ Customer Type(based on user.value.is_dealer, Consumer, Dealer )}} Faqs, Order Status, Return Policy, Shipping Information, Size Charts, Retail Locator, Contact Us
        user.value.is_dealer ? { 
            title: 'Dealer FAQs', 
            url: route('customer-service.faqs'), 
            caption: "Common questions from customers like you" ,
            aria_label: "Dealer FAQs"
        } : { 
            title: 'Consumer FAQs', 
            url: route('customer-service.faqs'), 
            caption: "Common questions from customers like you",
            aria_label: "Consumer FAQs"
        },
        { 
            title: 'Order Status', 
            url: route('order.lookup.show'),
            caption: "See the status of a current or past order",
            aria_label: "Order Status"
        },
        { 
            title: 'Return Policy', 
            url: route('customer-service.cms', ['consumer-return-policy']),
            caption: "Rothco return terms & process",
            aria_label: "Return Policy"
        },
        { 
            title: 'Shipping Information', 
            url: route('customer-service.cms', ['wholesale-shipping-information']),
            caption: "Our shipping & fulfillment processes",
            aria_label: "Shipping Information"
        },
        { 
            title: 'Size Charts', 
            url: route('customer-service.cms', ['size-charts']),
            caption: "Explore size charts for Rothco products",
            aria_label: "Size Charts"
        },
        { 
            title: 'Retail Locator', 
            url: route('retail.locator.search'),
            caption: "Find a Rothco dealer near you",
            aria_label: "Retail Locator"
        },
    ]
})
</script>
<template>
    <div class="featured_links">
        <featured-link v-for="(link, index) of featuredLinks" :featured-link="{
            title: link.title,
            caption: link.caption,
            link: link.url,
            aria_label: link.aria_label,
            
        }" :key="`featured-link-${index}`" />
    </div>
</template>